import { render } from "./TeamInvitationPreview.vue?vue&type=template&id=c61b4e12"
import script from "./TeamInvitationPreview.vue?vue&type=script&lang=js"
export * from "./TeamInvitationPreview.vue?vue&type=script&lang=js"

import "./TeamInvitationPreview.vue?vue&type=style&index=0&id=c61b4e12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__